import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const reconciliationSlice = createSlice({
  name: "reconciliationReducer",
  initialState: { 
    pageNo: 1, 
    pageSize: 10,
    searchParam: null, 
    selectedTab: "DISBURSEMENTS",
    isShowFilter: false 
  },
  
  reducers: {
    setReconciliationPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setReconciliationPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setReconciliationSearchParam: (state, action: PayloadAction<any>) => {
      state.searchParam = action.payload;
    },
    setReconciliationSelectedTab: (state, action: PayloadAction<string>) => {
      state.selectedTab = action.payload;
    },
    setReconciliationIsShowFilter: (state, action: PayloadAction<boolean>) => {
      state.isShowFilter = action.payload;
    }
  }
});

export const { 
  setReconciliationPageNo,
  setReconciliationPageSize,
  setReconciliationSearchParam,
  setReconciliationSelectedTab,
  setReconciliationIsShowFilter
} = reconciliationSlice.actions;
export default reconciliationSlice.reducer;
